import { Injectable } from '@angular/core';
import { ListTypes } from '@app/Constants';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { TenantService } from '../../../../../../Services';
import { ListItem } from '../../../Models/list-item';
import { TreeFlatNode, TreeNode } from '../../../Models/tree-node';
import { submissionNewNodeLevelToListAlias } from './submission-type-config.constants';

@Injectable()
export class SubmissionTypeConfigService {
  selectedNode: TreeFlatNode;
  newNodes: Subject<TreeFlatNode[]> = new Subject<TreeFlatNode[]>();
  nodeSelected: Subject<boolean> = new Subject<boolean>();
  deletedNode: Subject<TreeNode> = new Subject<TreeNode>();
  nodesInUse: Subject<string[]> = new Subject<string[]>();

  public constructor(private tenantService: TenantService) {}

  setActiveNode(node: TreeFlatNode): void {
    this.selectedNode = node;
    this.nodeSelected.next(true);
  }

  addNewNodes(nodesNames: ListItem[]): boolean {
    const tempParent: TreeNode = {} as TreeNode;
    Object.assign(tempParent, this.selectedNode);
    tempParent.children = [];
    tempParent.parent = null;

    const childLevel = 1;
    const newNodes = [];

    nodesNames.forEach((nodeName) => {
      const newNode = {
        isActive: true,
        allowAddChildren: this.selectedNode.level < childLevel,
        allowDelete: true,
        children: [],
        expandable: false,
        icon: submissionNewNodeLevelToListAlias.get(this.selectedNode.level)
          .iconName,
        level: this.selectedNode.level + 1,
        name: nodeName.Text,
        type: 'submission_type',
        uniqueIdentifier: nodeName.Value,
        parent: tempParent,
      } as TreeFlatNode;

      newNodes.push(newNode);
    });

    this.newNodes.next(newNodes);
    return true;
  }

  deleteNode(node: TreeNode): void {
    this.deletedNode.next(node);
  }

  async getListItems(listAlias: string): Promise<ListItem[]> {
    return await this.tenantService
      .getListItems([ListTypes.AirswebList, listAlias])
      .pipe(take(1))
      .toPromise();
  }
}
